<div class="quick-games-page">
  <div class="quick-games-header">
    <div>
      <h1 class="page-title">TRENDING <span class="title-accent">GAMES</span></h1>
      <p class="page-subtitle">The hottest games right now</p>
    </div>
    <div class="search-box">
      <i class="fas fa-search search-icon"></i>
      <input
        type="text"
        placeholder="Search games..."
        [(ngModel)]="searchTerm"
        (input)="onSearch()"
        class="search-input"
      />
    </div>
  </div>

  <div class="games-grid" *ngIf="filteredGames.length > 0; else noGames">
    <app-game-card
      *ngFor="let game of filteredGames"
      [game]="game"
      [statusLabel]="getStatus(game).label"
      [statusActive]="getStatus(game).active"
      (cardClick)="playGame(game)"
    ></app-game-card>
  </div>

  <ng-template #noGames>
    <div class="no-games-found">
      <p *ngIf="!loading">No games found.</p>
      <p *ngIf="loading">Loading trending games...</p>
    </div>
  </ng-template>
</div>

<!-- Login popup (shown when a logged-out user clicks a game) -->
<div *ngIf="showLoginModal" class="fixed inset-0 z-[1100]">
  <app-login [isPopup]="true" (closed)="closeLoginModal()"></app-login>
</div>
